import FormJaivana from 'dashboard_jaivana_v1';

/**
 *
 * @author Santiago_Hernandez
 * Migrado por Anderson Acevedo
 */
/**
 * Custom con funciones para la tabla nitsx_sedes_impuestos
 **/

class CustomImpuestosPorCliente extends FormJaivana.form {
    
    constructor(props) {
        super(props);
        this.initForm                       = this.initForm.bind(this);
        this.habilitarCampos                = this.habilitarCampos.bind(this);
        this.Deshabilitar                   = this.Deshabilitar.bind(this);
        this.validarAdicionar               = this.validarAdicionar.bind(this);
        this.successAdicionar               = this.successAdicionar.bind(this);
        this.cargarTabla                    = this.cargarTabla.bind(this);
        this.successCargarTabla             = this.successCargarTabla.bind(this);
        this.gridOptionsImpuestoTercero     = Object.assign({},this.gridOptions);
        this.limpiarCampos                  = this.limpiarCampos.bind(this);
        this.setButtonEliminar              = this.setButtonEliminar.bind(this);
        this.confirmarEliminacion           = this.confirmarEliminacion.bind(this);
        this.EliminarTerceroImpuestos       = this.EliminarTerceroImpuestos.bind(this);
        this.successEliminar                = this.successEliminar.bind(this);
        this.id_delete                      = 0;
        this.formatNumberSaldo              = this.formatNumberSaldo.bind(this);
        this.currencyFormatterGeneral       = this.currencyFormatterGeneral.bind(this);
        this.setButtonModificar             = this.setButtonModificar.bind(this);
        this.Modificar                      = this.Modificar.bind(this)
        this.modificar                      = false;


    }

    initForm() {
        console.log('Formulario CustomImpuestosPorCliente, @version: 1.01.0009.3 @author: Santiago Hernández N. Migrado por Anderson Acevedo @Update: Patricia Lopez Sanchez, Fecha:2025/05/28');
        this.Deshabilitar();
        this.getField('btn_Agregar').setClick(()=>{this.modificar = false; this.habilitarCampos()});
        this.getField('btn_adicionar').setClick(this.validarAdicionar);
        this.getField('btn_cancelar').setClick(this.Deshabilitar);
        //this.getField('nombre_proveedor').setOnChange(this.habilitarCampos);
    }

    habilitarCampos(){
        this.getField('terceros_id').setValue('');
        this.getField('nit').setValue('');
        this.getField('sede').setValue('');
        this.getField('nombre_proveedor').setValue('');
            
        this.getField('retefuente_tarifa').setValue('');
        this.getField('retefuente_base').setValue('');
        this.getField('reteica_tarifa').setValue('');
        this.getField('reteica_base').setValue('');

        this.getField('nit').setVisible(true);
        this.getField('sede').setVisible(true);
        this.getField('nombre_proveedor').setVisible(true);
        this.getField('nit').setDisabled(false);
        this.getField('sede').setDisabled(false);
        this.getField('nombre_proveedor').setDisabled(false);
        this.getField('retefuente_tarifa').setVisible(true);
        this.getField('retefuente_base').setVisible(true);
        this.getField('reteica_tarifa').setVisible(true);
        this.getField('reteica_base').setVisible(true);
        this.getField('btn_adicionar').setVisible(true);
        this.getField('btn_cancelar').setVisible(true);
        this.getField('btn_Agregar').setVisible(false);

        this.gridOptionsImpuestoTercero['rowData'] = [];
        this.getField('tb_terceroimpuestos').initData(this.gridOptionsImpuestoTercero);
        this.getField('tb_terceroimpuestos').toggle(false);
    }
    
    Deshabilitar(){
        this.getField('nit').setVisible(false);
        this.getField('sede').setVisible(false);
        this.getField('nombre_proveedor').setVisible(false);
        this.getField('retefuente_tarifa').setVisible(false);
        this.getField('retefuente_base').setVisible(false);
        this.getField('reteica_tarifa').setVisible(false);
        this.getField('reteica_base').setVisible(false);
        this.getField('btn_adicionar').setVisible(false);
        this.getField('btn_cancelar').setVisible(false);
    
        this.getField('retefuente_tarifa').setValue('');
        this.getField('retefuente_base').setValue('');
        this.getField('reteica_tarifa').setValue('');
        this.getField('reteica_base').setValue('');
    
        this.getField('nit').setError(false,"");
        this.getField('retefuente_tarifa').setError(false,"");
        this.getField('retefuente_base').setError(false,"");
        this.getField('reteica_tarifa').setError(false,"");
        this.getField('reteica_base').setError(false,"");
        this.getField('btn_Agregar').setVisible(true);
        this.cargarTabla();
    }

    validarAdicionar(){
        if(this.getField('retefuente_tarifa').valid() && this.getField('retefuente_base').valid() && this.getField('reteica_tarifa').valid() && this.getField('reteica_base').valid()){
            if(this.modificar){
                let datos={ datos: {
                    nitsx_sedes_id:this.getField('terceros_id').getValue(),
                    retefuente_tarifa:this.getField('retefuente_tarifa').getValue(),
                    retefuente_base:this.getField('retefuente_base').getValue(),
                    reteica_tarifa:this.getField('reteica_tarifa').getValue(),
                    reteica_base:this.getField('reteica_base').getValue(),
                }}
    
                this.generalFormatPmv = { tipo_servicio: 'maes-impuestosclienterete', operacion: 'modificar', operacion_tipo: 'modificar' };
                this.service.send(
                {
                        endpoint: this.constant.formConfiguration(),
                        method:'PUT',
                        body: datos,
                        success: this.successAdicionar,
                        error: this.error_,
                        general: this.generalFormatPmv,
                        showMessage: true
                });
            }else{
                let datos={ datos: {
                    nitsx_sedes_id:this.getField('terceros_id').getValue(),
                    retefuente_tarifa:this.getField('retefuente_tarifa').getValue(),
                    retefuente_base:this.getField('retefuente_base').getValue(),
                    reteica_tarifa:this.getField('reteica_tarifa').getValue(),
                    reteica_base:this.getField('reteica_base').getValue(),
                }}
    
                this.generalFormatPmv = { tipo_servicio: 'maes-impuestosclienterete', operacion: 'crear', operacion_tipo: 'crear' };
                this.service.send(
                {
                        endpoint: this.constant.formConfiguration(),
                        method:'POST',
                        body: datos,
                        success: this.successAdicionar,
                        error: this.error_,
                        general: this.generalFormatPmv,
                        showMessage: true
                });
            }
        }
    }

    successAdicionar(data){
        if(data.estado_p === 200){
            this.limpiarCampos();
            this.Deshabilitar();
        }else{
            if (data.data.mensaje !== undefined && data.data.mensaje !== null && data.data.mensaje !== ''){
                this.alertGeneral.toggle(true,data.data.mensaje,"error");
            }else{
                this.alertGeneral.toggle(true,"Error en la petición","error");
            }            
        }
    }

    
    cargarTabla(){
        let datos = {
            datos: {
                nitsx_sedes_id:this.getField('terceros_id').getValue()+'',
            }
        }

        //this.generalFormat.nombre_accion = '1292-servicio_consultarporterceroid';

        /*this.generalFormatPmv = { tipo_servicio: 'maes-impuestosclienterete', operacion: 'buscarxterceroid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successCargarTabla,
            error: this.error_,
            general: this.generalFormatPmv,
        });*/
        this.getField("tb_terceroimpuestos").setTipoServicioOperacion("maes-impuestosclienterete-buscarxterceroid");
        this.getField("tb_terceroimpuestos").sendRequest(this.successCargarTabla, datos);
    }

    successCargarTabla(data){
        if(data.estado_p === 200){
            let configCell = new Map(); // se añade boton "accion a la tabla
            configCell.set('eliminar',{cellRenderer:this.setButtonEliminar, field:'eliminar'});
            configCell.set('modificar',{cellRenderer:this.setButtonModificar, field:'modificar'});
            configCell.set('retefuente_tarifa', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.retefuente_tarifa) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('retefuente_base', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.retefuente_base) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('reteica_tarifa', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.reteica_tarifa) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('reteica_base', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.reteica_base) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('sede', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.sede) }, cellStyle: {textAlign:"right"},width: 110});

            
            this.gridOptionsImpuestoTercero['rowData'] = data.data;

            this.getField('tb_terceroimpuestos').initData(this.gridOptionsImpuestoTercero,configCell);            
        }else{
            this.gridOptionsImpuestoTercero['rowData'] = [];
            this.getField('tb_terceroimpuestos').initData(this.gridOptionsImpuestoTercero);
            this.getField('tb_terceroimpuestos').toggle(false);
        }   
    }

    limpiarCampos(){
        this.getField('terceros_id').setValue('');
        this.getField('nit').setValue('');
        this.getField('sede').setValue('');
        this.getField('nombre_proveedor').setValue('');
        this.getField('retefuente_tarifa').setValue('');
        this.getField('retefuente_base').setValue('');
        this.getField('reteica_tarifa').setValue('');
        this.getField('reteica_base').setValue('');

        this.getField('retefuente_tarifa').setError(false,"");
        this.getField('retefuente_base').setError(false,"");
        this.getField('reteica_tarifa').setError(false,"");
        this.getField('reteica_base').setError(false,"");
    }

    setButtonEliminar(props){//accion del boton eliminar

        let button = document.createElement("input");
        button.onclick = ()=>this.confirmarEliminacion(props.data.id);
        button.setAttribute("id",'button_aprove_');
        button.setAttribute("class","buttonStyle");//,"width:100%; height: 100%; background-color:#303f9f;color:#fff;border:1px solid #303f9f;padding-left:5px;padding-rigth:5px;padding-top:2px;padding-bottom:2px;border-radius:3px; cursor:pointer");
        button.setAttribute("type","button");
        button.setAttribute("value","Eliminar");
        return this.createElementJaivana(button);

    }

    confirmarEliminacion(id){//permite eliminar el id_categorias asociado a el articulo      
        this.id_delete = id;  
        this.getField('confirmModalCustom').setTitleAndContent('Eliminar','Desea realizar esta operación?');
        this.getField('confirmModalCustom').setClickDialog(this.EliminarTerceroImpuestos);
        this.getField('confirmModalCustom').toggle(true);

    }

    EliminarTerceroImpuestos(){
        this.getField('confirmModalCustom').toggle(false);

        if(this.id_delete !== ''){

            let datos = {
                datos: {
                    id: this.id_delete,
                }
            }
            //this.generalFormat.nombre_accion = '1292-servicio_eliminar';

            this.generalFormatPmv = { tipo_servicio: 'maes-impuestosclienterete', operacion: 'eliminar', operacion_tipo: 'eliminar' };
            this.service.send(
            {
                    endpoint: this.constant.formConfiguration(),
                    method:'DELETE',
                    body: datos,
                    success: this.successEliminar,
                    error: this.error_,
                    general: this.generalFormatPmv,
                   //showMessage: false
            });
        }
    }

    setButtonModificar(props){//accion del boton eliminar

        let button = document.createElement("input");
        button.onclick = ()=>this.Modificar(props.data);
        button.setAttribute("id",'button_aprove_');
        button.setAttribute("class","buttonStyle");//,"width:100%; height: 100%; background-color:#303f9f;color:#fff;border:1px solid #303f9f;padding-left:5px;padding-rigth:5px;padding-top:2px;padding-bottom:2px;border-radius:3px; cursor:pointer");
        button.setAttribute("type","button");
        button.setAttribute("value","Modificar");
        return this.createElementJaivana(button);

    }

    Modificar(data){
        this.modificar = true;
        this.habilitarCampos();
        this.getField('nit').setDisabled(true);
        this.getField('sede').setDisabled(true);
        this.getField('nombre_proveedor').setDisabled(true);
        this.getField('nit').setValue(data.nit);
        this.getField('sede').setValue(data.sede);
        this.getField('nombre_proveedor').setValue(data.nombre);
        this.getField('retefuente_tarifa').setValue(data.retefuente_tarifa);
        this.getField('retefuente_base').setValue(data.retefuente_base);
        this.getField('reteica_tarifa').setValue(data.reteica_tarifa);
        this.getField('reteica_base').setValue(data.reteica_base);
        this.getField('terceros_id').setValue(data.nitsx_sedes_id);
    }

    currencyFormatterGeneral(number)
    {
            let decimal = (number + "").split(".")[1];//para manejar los decimales
             /*if ((decimal !== 0) && (decimal !== undefined)) {
              if(decimal.length>this.numero_decimales_compras){
                number=number.toFixed(this.numero_decimales_compras); //para que redondea a dos decimales
                decimal = (number + "").split(".")[1];
              }
              return (this.formatNumberSaldo(number) + "," + decimal);
             } else {
              return this.formatNumberSaldo(number); 
            }*/

            if ((decimal !== 0) && (decimal !== undefined)) {
              return (this.formatNumberSaldo(number) + "," + decimal);
             } else {
              return this.formatNumberSaldo(number); 
            }
    }

    formatNumberSaldo(number)
    {
            return Number(number).toString().split('.')[0]
             .toString()
             .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }

    successEliminar(data){
        if(data.estado_p === 200){
            this.cargarTabla();
            this.limpiarCampos();
        }else{
            this.alertGeneral.toggle(true,"Error en la petición","error");
        }
    }

}

FormJaivana.addController("maes-impuestosclienterete",CustomImpuestosPorCliente);
export default CustomImpuestosPorCliente;